var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F6450EBB-67AC-46D7-A447-DA1AD369A4A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-30.0%",
    y: "-15.0%",
    width: "160.0%",
    height: "160.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784314   0 0 0 0 0.278431373   0 0 0 0 0.992156863  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-3-6---Changing-a-policy-status-from-the-table-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-6-2---Changing-a-policy-status-from-the-table-view",
    transform: "translate(-1231.000000, -732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.-Other-Buttons-&-Controls/02.-Checkbox/01.-Inactive",
    transform: "translate(1234.000000, 732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2CE68F",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#F9FFFC",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_tick",
    transform: "translate(4.000000, 4.000000)",
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8330911,0.244844527 C10.9345607,0.0642977241 11.1631801,0.000192950108 11.3437269,0.101662506 C11.5113775,0.195884237 11.5786266,0.399740298 11.506136,0.572937746 L11.4869089,0.612298296 L5.31119462,11.6008698 C5.19356575,11.8101691 4.91605918,11.8536549 4.74014353,11.7019 L4.70639242,11.6689371 L0.36496383,6.87750848 C0.225901737,6.72403225 0.237586703,6.48688309 0.391062932,6.34782099 C0.532733298,6.21945598 0.745698948,6.21953817 0.88700071,6.34102358 L0.920750422,6.37392009 L4.91223213,10.7793214 L10.8330911,0.244844527 Z",
    id: "interface-validation-check-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInput);
export default __webpack_public_path__ + "static/media/Active_Input.7ae239d0cb1851c71ea9723e3ae295ff.svg";
export { ForwardRef as ReactComponent };